import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { FinanciacionPropiaModel } from './financiacion-propia.model';
import { FinanciacionPropiaService } from './financiacion-propia.service';

@Component({
    selector: 'convfact-financiacion-propia',
    templateUrl: './financiacion-propia.component.html',
    styleUrls: ['./financiacion-propia.component.css'],
    standalone: false
})

export class FinanciacionPropiaComponent implements OnInit {

  public financiacionPropia = new FinanciacionPropiaModel;
  public spinner: boolean = false;
  public ready: boolean = false;
  public spinnerMessage: string = 'Cargando financiación propia…';

  constructor(
    private financiacionPropiaService: FinanciacionPropiaService,
    public snackBar: MatSnackBar,
    private router: Router
  ) { }

  public ngOnInit(): void {
    const temp = this.router.url.split('/');
    this.spinner = true;
    if (temp.length == 6) {
      const uid = temp[5];
      this.financiacionPropiaService.get(uid)
        .then(response => {
          if (response) {
            this.financiacionPropia = response;
          }
          this.spinner = false;
          this.ready = true;
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(this.serverMessage(error) || "No se pudo cargar la financiación propia");
          this.returnToIndex();
        });
    }
    else {
      this.spinner = false;
      this.ready = true;
    }

  }

  public saveData(financiacionPropia: FinanciacionPropiaModel): void {
    if (this.spinner) {
      return;
    }

    this.spinnerMessage = 'Guardando financiación propia…';
    this.spinner = true;

    if (financiacionPropia.uid == null) {
      this.financiacionPropiaService.add(financiacionPropia)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(this.serverMessage(error) || "Ha ocurrido un error inesperado al crear la financiación propia");
        })
    } else {
      this.financiacionPropiaService.edit(financiacionPropia)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(this.serverMessage(error) || "Ha ocurrido un error inesperado al actualizar la financiación propia")
        })
    }
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    options.panelClass = ['snack-error'];
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['finance/loans/selffinancing']);
  }

  private serverMessage(error: any): string {
    return (error && error.error && error.error.message) || '';
  }

}
